import PageWrapper from "components/page-wrapper";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import paths from "routes/paths";

type Props = {
  signup?: boolean;
};

export const RequireAuth = ({ signup = false }: Props) => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(
      signup
        ? paths.authSignup({ successUrl: window.location.href })
        : paths.authLogin({ successUrl: window.location.href }),
    );
  }, [navigate, signup]);

  return <PageWrapper loading />;
};
